if (!customElements.get('content-column-block')) {
  customElements.define(
    'content-column-block',
    class ContentColumnBlock extends HTMLElement {
      connectedCallback() {
        this.body = this.querySelector('.content-column__body--clamped');
        this.toggleButton = this.querySelector('.content-column__read-more');
        if (!this.body || !this.toggleButton) return;

        this.toggleButton.addEventListener('click', this.onToggleClick.bind(this));
        this.resizeObserver = new ResizeObserver(() => this.updateVisibility());
        this.resizeObserver.observe(this.body);
        this.updateVisibility();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      updateVisibility() {
        if (this.classList.contains('content-column-block--expanded')) return;
        const isOverflowing = this.body.scrollHeight > this.body.clientHeight + 1;
        this.toggleButton.hidden = !isOverflowing;
      }

      onToggleClick() {
        const expanded = this.classList.toggle('content-column-block--expanded');
        this.toggleButton.setAttribute('aria-expanded', expanded);
        this.toggleButton.textContent = expanded
          ? this.toggleButton.dataset.lessLabel
          : this.toggleButton.dataset.moreLabel;
        if (!expanded) this.updateVisibility();
      }
    }
  );
}
